import { difference } from 'lodash';
import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { DsInputStates } from '@levelaccess/design-system';

import { AccessibilityAuditToolNames } from '../../../../shared/constants/audit-tool';
import { SharedCommonUtility } from '../../../../shared/utils/common.utility';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { filterRulebaseIfNecessary } from '../../utility/rulebase.utility';

@Component({
  selector: 'app-testing-tool-filter',
  templateUrl: './testing-tool-filter.component.html',
  standalone: false,
})
export class TestingToolFilterComponent {
  @Input() public set currentSelection(selection: AccessibilityAuditToolNames) {
    if (SharedCommonUtility.notNullish(selection)) {
      this.currentValue = selection;
    }
  }
  @Input() public toolsToExclude: AccessibilityAuditToolNames[];
  @Input({ transform: booleanAttribute }) public flexFill: boolean = false;
  @Output() public onToolSelected: EventEmitter<AccessibilityAuditToolNames>;

  public DsInputStates: typeof DsInputStates;
  public auditToolNames: typeof AccessibilityAuditToolNames;
  public currentValue: AccessibilityAuditToolNames;

  constructor(private featureFlagService: FeatureFlagService) {
    this.DsInputStates = DsInputStates;
    this.auditToolNames = AccessibilityAuditToolNames;
    this.onToolSelected = new EventEmitter<AccessibilityAuditToolNames>();
    this.currentValue = AccessibilityAuditToolNames.ibm;
  }

  public get toolsToList(): AccessibilityAuditToolNames[] {
    const auditToolNamesKeys: AccessibilityAuditToolNames[] = Object.values(this.auditToolNames)
      .filter((toolName: AccessibilityAuditToolNames): boolean => filterRulebaseIfNecessary(this.featureFlagService, toolName))
      .filter((toolName: AccessibilityAuditToolNames): boolean => toolName !== AccessibilityAuditToolNames.mobile_engine);
    let filteredAuditTools: AccessibilityAuditToolNames[] = auditToolNamesKeys;
    if (SharedCommonUtility.notNullishOrEmpty(this.toolsToExclude)) {
      filteredAuditTools = difference(auditToolNamesKeys, this.toolsToExclude);
    }

    return filteredAuditTools;
  }

  public onToolSelect(toolName: AccessibilityAuditToolNames): void {
    this.onToolSelected.emit(toolName);
    this.currentValue = toolName;
  }
}
